import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const CaretRightIcon = ({
  round,
  containerColor,
  containerSize,
  color,
  size,
  onClick,
  className,
}) => (
  <WithIconRounded
    round={round}
    containerColor={containerColor}
    containerSize={containerSize}
    className={className}
    onClick={onClick}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.97656 6.00011L0.851562 1.87511L2.0299 0.696777L7.33323 6.00011L2.0299 11.3034L0.851562 10.1251L4.97656 6.00011Z"
        fill={color}
      />
    </svg>
  </WithIconRounded>
);

CaretRightIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

CaretRightIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: '#B4BACA',
  containerColor: null,
  containerSize: 40,
  onClick: null,
  round: false,
  size: 12,
};

export default CaretRightIcon;
